import { render } from "./TargetIcon.vue?vue&type=template&id=18995bea"
import script from "./TargetIcon.vue?vue&type=script&lang=js"
export * from "./TargetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__